import React from "react";

export const Input = ({ className = "", ...props }) => {
  return (
    <input
      {...props}
      className={`w-full px-4 py-2 border rounded-lg outline-none focus:ring ${className}`}
    />
  );
};
